var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "iframe-container" },
    [
      _vm.posterUrl
        ? _c(
            "figure",
            {
              staticClass: "iframe__poster figure-gradient",
              class: [{ "iframe__poster--playing": _vm.isPlaying }]
            },
            [
              _c("img", {
                ref: "poster",
                attrs: {
                  src: _vm.posterUrl,
                  alt: "Poster",
                  width: "1280",
                  height: "720",
                  loading: "lazy"
                }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button iframe__play",
                  attrs: { type: "button", value: "Play Youtube Video" },
                  on: { click: _vm.playVideo }
                },
                [
                  _c("i", { staticClass: "icon icon-play" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          version: "1.1",
                          xmlns: "http://www.w3.org/2000/svg",
                          "xmlns:xlink": "http://www.w3.org/1999/xlink",
                          x: "0px",
                          y: "0px",
                          viewBox: "0 0 25 27",
                          "enable-background": "new 0 0 25 27",
                          "xml:space": "preserve"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            fill: "currentColor",
                            d:
                              "M24,12.3L2.4,0.2C1.9-0.1,1.4-0.1,1,0.2C0.6,0.4,0.4,0.9,0.4,1.4v24.3c0,0.5,0.3,0.9,0.7,1.2\n          C1.2,26.9,1.5,27,1.7,27c0.2,0,0.5-0.1,0.7-0.2L24,14.7c0.4-0.2,0.7-0.7,0.7-1.2S24.4,12.6,24,12.3z"
                          }
                        })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "visually-hidden" }, [
                    _vm._v("Play Youtube Video")
                  ])
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("youtube", {
        ref: "youtube",
        attrs: { "video-id": _vm.videoId },
        on: { ended: _vm.endVideo }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }